// /**axios封装
//  * 请求拦截、相应拦截、错误统一处理
//  */
// import {
// 	baseUrl
// } from './env.js'

// import axios from 'axios';
// import {
// 	Message
// } from 'element-ui';
// import {
// 	decrypt
// } from "@/utils/decrypt.js"
// import store from '../store/index';
// import router from '../router/index';
// axios.defaults.timeout = 10000; //设置请求时间
// axios.defaults.baseURL = baseUrl; //设置默认接口地址



// // post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


// axios.interceptors.request.use(
// 	config => {

// 		var token = localStorage.getItem("token");
// 		if (token) {
// 			config.headers.Authorization = token
// 		}
// 		// //console.log(token);
// 		// var token_time = localStorage.getItem("token_time") * 1000;
// 		// var day = new Date().getTime();
// 		// //console.log(token_time);
// 		// if (token && token !== null) {
// 		// 	if (token_time > day) {
// 		// 		config.headers.Authorization = localStorage.getItem('token');
// 		// 	} else {
// 		// 		// config.headers.appId = 1;
// 		// 		// config.headers.appId = 1;
// 		// 	}

// 		// } else {
// 		// 	// config.headers.appId = 1;
// 		// 	// config.headers.appId = 1;
// 		// }
// 		return config;
// 	},
// 	error => {
// 		return Promise.reject(error);
// 	});

// // 响应拦截器
// axios.interceptors.response.use(
// 	response => {
// 		try{
// 			if(typeof response.data.data == 'string'){
// 				response.data.data = decrypt(response.data.data)
// 			}
// 		}catch(res){
			
// 		}
// 		if (response.data.code === 200 || response.data.code === 1) {
// 			//console.log(1);
// 			if (response.data.token) {
// 				if (response.data.token.token && response.data.token.token !== '') {
// 					localStorage.setItem("token", response.data.token.token);
// 					localStorage.setItem("token_time", response.data.token.exp);
// 					// //console.log( localStorage.getItem("token"));
// 				}
// 			}
// 			//console.log(response)
// 			return Promise.resolve(response);
// 		} else if (response.data.code === 2001 || response.data.code === 2000 || response.data.code === 1002 ||
// 			response.data.code === 2002) {
// 			//console.log(2)
// 			localStorage.removeItem("token");
// 			localStorage.setItem("user_id", '');
// 			localStorage.setItem("user_name", '');
// 			localStorage.setItem("user_image", '');
// 			localStorage.setItem("user_vip", '');

// 			Message.error({
// 				message: response.data.msg
// 			});
// 			return Promise.reject(response);
// 		} else {
// 			//console.log(3)
// 			Message.error({
// 				message: response.data.msg
// 			});
// 			return response
// 		}

// 	},
// 	// 服务器状态码不是200的情况 
// 	error => {
// 		localStorage.removeItem("token");
// 		localStorage.setItem("user_id", '');
// 		localStorage.setItem("user_name", '');
// 		localStorage.setItem("user_image", '');
// 		localStorage.setItem("user_vip", '');
// 		MessageBox.$confirm('', '提示', {
// 			confirmButtonText: '确定',
// 			cancelButtonText: '取消',
// 			type: 'warning'
// 		}).then(() => {
// 			router.push({
// 				path: '/'
// 			})
// 		}).catch(() => {

// 		});
// 		setTimeout(() => {
// 			router.go(0)
// 		}, 1500);
// 		return Promise.reject(error.response);
// 	}

// );


// /** 
//  * get方法，对应get请求 
//  * @param {String} url [请求的url地址] 
//  * @param {Object} params [请求时携带的参数] 
//  */
// export function get(url, params) {
// 	return new Promise((resolve, reject) => {
// 		axios.get(url, {
// 				params: params
// 			}, )
// 			.then(res => {
// 				resolve(res.data);
// 			})
// 			.catch(err => {
// 				reject(err.data)
// 			})
// 	});
// }
// /** 
//  * post方法，对应post请求 
//  * @param {String} url [请求的url地址] 
//  * @param {Object} params [请求时携带的参数] 
//  */
// export function post(url, params) {
// 	return new Promise((resolve, reject) => {
// 		axios.post(url, params)
// 			.then(res => {
// 				resolve(res.data);
// 			})
// 			.catch(err => {
// 				reject(err.data)

// 			})
// 	});
// }

// //跳转页面刷新
// export function link(query) {
// 	return new Promise(() => {
// 		this.$router.replace({
// 			path: '/link',
// 			query: query
// 		});

// 	});
// }

// 动态加载js文件
export function addScript(url, id) {
	return new Promise((resovle, reject) => {
		let srcArr = document.getElementsByTagName('script');
		let hasLoaded = false;
		for (let i = 0; i < srcArr.length; i++) {
			hasLoaded = srcArr[i].src === url;
			// 如果找到了重复的js标签将它删除
			if (hasLoaded) {
				document.getElementById(id).remove();
			}
		}
		//创建script标签,并为此标签添加ID
		let script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = url;
		script.id = id;
		//添加标签到body尾部
		document.getElementsByTagName("head")[0].appendChild(script);

		script.onload = () => {
			resovle();
		};
		script.onerror = () => {
			reject();
		}
	})
}
